// extracted by mini-css-extract-plugin
export var searchHeader = "_p-0";
export var searchHeaderDark = "_p-1";